module.exports = __webpack_public_path__ + "media/application/images/ui/tick-9d2f4af8f49d684251a89752cf1cd019.png";